import type CalendarCloudSetting from '../store/schema/CalendarCloudSetting';
import { CalendarCloudSettingType } from '../store/schema/CalendarCloudSettingType';
import normalizeShortenEventScopeValue from './normalizeShortenEventScopeValue';
import validateRoamingTimezonesValue from './validateRoamingTimezonesValue';
import {
    validateGlobalCalendarLanguageValue,
    validateGlobalCalendarTypeValue,
} from './validateGlobalCalendarSettings';

/**
 * Converts the OCS settings or prime settings to the CalendarCloudSettings
 * @param settings
 */
export default function convertSettingsToCalendarCloudSettings(
    settings: any[] | undefined
): CalendarCloudSetting[] | null {
    if (!settings || settings.length == 0) {
        return null;
    }

    const calendarCloudSettings: CalendarCloudSetting[] = [];
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS7034 (21,9): Variable 'settingValue' implicitly has type 'any' in some locations where its type cannot be determined.
    // @ts-expect-error
    let settingValue;

    settings.forEach(setting => {
        if (!setting.name || !setting.value) {
            return;
        }

        switch (setting.name.toLowerCase()) {
            case CalendarCloudSettingType.ShouldEventsEndEarly.toLowerCase():
                settingValue = setting.value.toLowerCase() === 'true';
                break;
            case CalendarCloudSettingType.ShortenEventScope.toLowerCase():
                settingValue = normalizeShortenEventScopeValue(setting.value);
                break;
            case CalendarCloudSettingType.EndShortEventsBy.toLowerCase():
                settingValue = Number(setting.value);
                break;
            case CalendarCloudSettingType.EndLongEventsBy.toLowerCase():
                settingValue = Number(setting.value);
                break;
            case CalendarCloudSettingType.EnableOnlineMeetingsByDefault.toLowerCase():
                settingValue = setting.value.toLowerCase() === 'true';
                break;
            case CalendarCloudSettingType.RoamingTimezones.toLowerCase():
                settingValue = validateRoamingTimezonesValue(setting.value);
                break;
            case CalendarCloudSettingType.PrimaryTimezoneLabel.toLowerCase():
                settingValue = setting.value;
                break;
            case CalendarCloudSettingType.GlobalCalendarEnabled.toLowerCase():
                settingValue = setting.value.toLowerCase() === 'true';
                break;
            case CalendarCloudSettingType.GlobalCalendarLanguage.toLowerCase():
                settingValue = validateGlobalCalendarLanguageValue(setting.value);
                break;
            case CalendarCloudSettingType.GlobalCalendarType.toLowerCase():
                settingValue = validateGlobalCalendarTypeValue(setting.value);
                break;
            case CalendarCloudSettingType.RokuyouDays.toLowerCase():
                settingValue = Number(setting.value);
                break;
            case CalendarCloudSettingType.HijriOffset.toLowerCase():
                settingValue = Number(setting.value);
                break;
        }

        // Check for null or undefined values
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS7005 (56,13): Variable 'settingValue' implicitly has an 'any' type.
        // @ts-expect-error
        if (settingValue != null) {
            calendarCloudSettings.push({
                name: setting.name,
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7005 (62,24): Variable 'settingValue' implicitly has an 'any' type.
                // @ts-expect-error
                value: settingValue,
                source: setting.source,
            });
        }
    });

    return calendarCloudSettings.length === 0 ? null : calendarCloudSettings;
}
